import { render, staticRenderFns } from "./InvestmentStep.vue?vue&type=template&id=3dc5e41e&scoped=true"
import script from "./InvestmentStep.vue?vue&type=script&lang=ts&setup=true"
export * from "./InvestmentStep.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./InvestmentStep.vue?vue&type=style&index=0&id=3dc5e41e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc5e41e",
  null
  
)

export default component.exports